import React, { useState, useCallback, useEffect, useContext } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useParams, useHistory } from "react-router-dom";
import { UserContext } from "context/user";
import { getOrder } from "api/Order";
import { createPayment } from "api/Payment";
import appLogo from "assets/logo/logo-only.png";
import stripeLogo from "assets/logo/stripe.svg";
import StripeCardElement from "./components/StripeCardElement";
import "./index.scss";

const STRIPE_PK = process.env.REACT_APP_STRIPE_PUBLISHER_KEY;
const stripePromise = loadStripe(STRIPE_PK);

const StripeContainer = () => {
  const history = useHistory();
  const { token } = useContext(UserContext);
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  const orderTotal = order ? order?.data?.order_total / 100 : null;

  const fetchOrder = useCallback(async () => {
    if (!token) return;

    const orderData = await getOrder(orderId, token);
    if (orderData?.data?.payment_method !== "stripe") {
      history.goBack();
    }
    setOrder(orderData);
  }, [orderId, token, history]);

  useEffect(() => {
    fetchOrder();
  }, [fetchOrder]);

  const createPaymentIntent = async () => {
    const payment = await createPayment(orderId, token);
    return payment;
  };

  if (!order) return null;

  return (
    <div className="stripe-wrapper">
      <div className="header-panel">
        <span className="icon-image" />
        <h1 className="title">High Resolution Ordering</h1>
        <img className="app-logo" src={appLogo} alt="alt" />
      </div>
      <div className="main-container">
        <div className="payment-title">
          <h2 className="page-title">Payment</h2>
          <img className="stripe-logo" src={stripeLogo} alt="alt" />
        </div>
        <div className="total-price">
          <label className="label">Total Price</label>
          <h2 className="price">
            ${" "}
            {orderTotal.toLocaleString(undefined, { minimumFractionDigits: 2 })}
          </h2>
          <label className="label">GST Inclusive</label>
        </div>
        <Elements stripe={stripePromise}>
          <StripeCardElement
            amount={orderTotal.toLocaleString(undefined, {
              minimumFractionDigits: 2,
            })}
            createPaymentIntent={() => createPaymentIntent()}
            order={order.data}
          />
        </Elements>
      </div>
    </div>
  );
};

export default StripeContainer;
